
class ForgotPassword {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
    }
    onInit () {
        console.log('1')
        const note = this._elem.querySelector('[data-forgot-note]')
        if (note) {
            console.log('2')
            const check = document.querySelector('[data-forgot-check]')
            if (check) {
                console.log('3')
                check.checked = true
            }
        }
    }
}

export default ForgotPassword



// WEBPACK FOOTER //
// ./src/resources/scripts/components/ForgotPassword.js